const isQuotaError = (e) =>
  e && (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED' || e.code === 22 || e.code === 1014);

const evictRebuildableCaches = () => {
  Object.keys(localStorage)
    .filter(k => k === 'cached_products_data' || (k.startsWith('picking-') && k !== 'picking-cache-version'))
    .forEach(k => localStorage.removeItem(k));
};

export const safeSetItem = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    if (!isQuotaError(e)) throw e;
    evictRebuildableCaches();
    localStorage.setItem(key, value);
  }
};
